module.exports = __webpack_public_path__ + "media/music/piano_8-0d30030b.mp3";